/**
 * Support: the queue and one ticket.
 *
 * This file was 565 lines holding the list, the detail, the new-ticket dialog,
 * the saved-replies manager and two hand-written colour maps. It is the routes
 * now; everything it used to contain lives next to it under its own name.
 */
import { Route, Routes } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { TicketsList } from "./TicketsList";
import { TicketDetail } from "./TicketDetail";

export function SupportSection({ user: _user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route path="/" element={<TicketsList />} />
      <Route path="/:id" element={<TicketDetail />} />
    </Routes>
  );
}
